import { classNames } from "primereact/utils";
import { useHistory, useLocation } from "react-router-dom";
import localeText from "../../../../locale";
import ChannelCashbackSection from "./ChannelCashbackSection";
import ChannelConfigSection from "./ChannelConfigSection";
import ChannelSalesSection from "./ChannelSalesSection";
import ChannelSellersSection from "./ChannelSellersSection";
import "./AdminScontiPoste.css";

const TABS = [
  { value: "config", labelKey: "adminChannelTabConfig", Component: ChannelConfigSection },
  { value: "sellers", labelKey: "adminChannelTabSellers", Component: ChannelSellersSection },
  { value: "sales", labelKey: "adminChannelTabSales", Component: ChannelSalesSection },
  { value: "cashback", labelKey: "adminChannelTabCashback", Component: ChannelCashbackSection },
];

// Admin do canal ScontiPoste: link da vitrine, abrir/fechar e %, Managers, vendas e provisao de cashback
const AdminScontiPoste = () => {
  const location = useLocation();
  const history = useHistory();
  const current = new URLSearchParams(location.search).get("tab");
  const tab = TABS.find((t) => t.value === current) || TABS[0];

  return (
    <div className="admin-list">
      <div className="admin-list-tabs" role="tablist" aria-label={localeText("adminChannelMenu")}>
        {TABS.map((t) => (
          <button
            key={t.value}
            type="button"
            role="tab"
            aria-selected={t.value === tab.value}
            className={classNames("admin-list-tabs__tab", { "admin-list-tabs__tab--active": t.value === tab.value })}
            onClick={() => history.replace({ search: `?tab=${t.value}` })}
          >
            {localeText(t.labelKey)}
          </button>
        ))}
      </div>
      {/* key: trocar de aba recria a secao (recarrega os dados) */}
      <tab.Component key={tab.value} />
    </div>
  );
};

export default AdminScontiPoste;
